import React, { useState } from "react";

import {
  Box,
  Collapse,
  IconButton,
  makeStyles,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { MedicamentoItem } from "../gestionEmpadronamiento/MedicamentoItem";
import { DiagnosticoItem } from "../gestionEmpadronamiento/DiagnosticoItem";

const useStyles = makeStyles({
  iconEstado: {
    "&:hover": {
      backgroundColor: "#80808026",
    },
  },
});

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const EmpadronamientoHistorialItem = (props) => {
  const classes = useStyles();

  const [open, setOpen] = React.useState(false);
  const [openDiag, setOpenDiag] = useState(false);

  const { solicitud, ocultarEstado } = props;

  return (
    <React.Fragment>
      <TableRow className={classes.iconEstado}>
        {!ocultarEstado && <TableCell>{new Date(solicitud?.fechaFin) > new Date() ? solicitud?.estadoSolicitud?.descripcion : "Inactiva"}</TableCell>}
        <TableCell>{solicitud?.idSolicitud}</TableCell>
        <TableCell>
          {new Date(solicitud?.fechaInicio).toLocaleString("es", optionsfecha)}
        </TableCell>
        <TableCell>
          {solicitud?.fechaFin !== null ? new Date(solicitud?.fechaFin).toLocaleString("es", optionsfecha) : new Date('2099-12-31').toLocaleString("es", optionsfecha)}
        </TableCell>
        <TableCell align="left">{solicitud?.tipoEmpadronamiento?.descripcion}</TableCell>
        <TableCell align="left">{solicitud?.usuario?.userName}</TableCell>
        <TableCell>
          {solicitud.diagnosticos.length > 0 && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpenDiag(!openDiag)}
            >
              {openDiag ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCell>
        <TableCell>
          {solicitud.medicamentos.length > 0 && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0, paddingLeft: 20 }}
          colSpan={3}
        >
          <Collapse in={openDiag} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Diagnósticos
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Descripción</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {solicitud.diagnosticos.map((diagnostico) => (
                    <DiagnosticoItem
                      key={diagnostico?.idDiagnostico?.toString()}
                      item={diagnostico}
                    />
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0, paddingLeft: 20 }}
          colSpan={9}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Medicamentos
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Presentación</TableCell>
                    <TableCell>Laboratorio</TableCell>
                    <TableCell>Nombre</TableCell>
                    <TableCell>Drogas</TableCell>
                    <TableCell align="right">Cantidad</TableCell>
                    <TableCell>Dosis</TableCell>
                    <TableCell>Posología</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {solicitud.medicamentos.filter((medicamento) => medicamento.fechaBaja == null).map((medicamento) => (
                    <MedicamentoItem
                      key={medicamento?.idMedicamento?.toString()}
                      item={medicamento}
                    />
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};
